const autocompleteCalendarFilter = {
  sites: 'Sites',
  users: 'Accountable / Inspected By',
  equipments: 'Equipment Type',
  equipmentGroups: 'Equipment Group',
  serviceTypes: 'Service Type',
  frequencies: 'Frequency',
  areas: 'Departments',
  company: 'Third Companies'

};

export default autocompleteCalendarFilter;
